import i18next from 'i18next';
import SignalStrengthHelper from "./signal_strength_helper";
import { DeviceDataOverrideService } from '../services';

class FormatHelper {
    
    static formatMeasurement(threshold, datapoint) {
        let evaluationValue;

        if (datapoint) {
          if (datapoint.numericValue != null) {
            evaluationValue = datapoint.numericValue;
          } else if (datapoint.stringValue != null) {
            evaluationValue = datapoint.stringValue;
          } else if (datapoint.booleanValue != null) {
            evaluationValue = datapoint.booleanValue;
          } else {
            return null;
          }
        } else {
          if (threshold.displayableEvaluationNumericValue != null) {
            const deviceDataTypeToken = threshold.deviceDataType?.token ?? threshold.deviceDataClassification?.token;
            const fnToApply = DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(deviceDataTypeToken);
            evaluationValue = fnToApply(threshold.displayableEvaluationNumericValue);
          } else if (threshold.displayableEvaluationStringValue != null) {
            evaluationValue = threshold.displayableEvaluationStringValue;
          } else if (threshold.displayableEvaluationBooleanValue != null) {
            evaluationValue = "" + threshold.displayableEvaluationBooleanValue;
          } else {
            return null;
          }
        }

        const potentialTranslatedValue = `data-string-display.${threshold.deviceDataType?.token}.${evaluationValue}`;
        if (i18next.t(potentialTranslatedValue) !== potentialTranslatedValue) {
          return i18next.t(potentialTranslatedValue);
        } else if (threshold.deviceDataType?.token === 'rssi') {
          return `${evaluationValue} (${SignalStrengthHelper.renderRSSIValue(evaluationValue)})`;
        } else if (threshold.deviceDataType?.token === 'magnetometer') {
          return i18next.t(`magnetometer-data-string-display.${evaluationValue}`);
        } else if (threshold.deviceDataType?.token === 'door_state') {
          return  i18next.t(`door-state-data-string-display.${evaluationValue}`);
        } else if (threshold.deviceDataType?.token === 'power_status') {
          return i18next.t(`power-status-data-string-display.${evaluationValue}`); 
        } else if (threshold.deviceDataType?.deviceDataDisplayType && threshold.deviceDataType?.deviceDataDisplayType.format) {
          return sprintf(DeviceDataOverrideService.getOverrideForDisplayFormat(threshold.deviceDataType.deviceDataDisplayType.format), evaluationValue);
        }

        const classificationDisplayTypes = threshold.deviceDataClassification?.deviceDataClassificationDisplayTypes;
        if (classificationDisplayTypes && classificationDisplayTypes.length > 0 && classificationDisplayTypes[0].format) {
          return sprintf(DeviceDataOverrideService.getOverrideForDisplayFormat(classificationDisplayTypes[0].format), evaluationValue);
        }

        return evaluationValue;
    }

    static formatPhoneNumbers(preferences, property="sms") {
      return preferences.map((op) => {
        let pref = {...op};
        if (pref[property] !== '+1') {
          if (property === 'voice') {
            pref['sendVoicePrefix'] = pref[property].sendVoicePrefix;
            pref[property] = this.formatPhoneNumber(pref[property].number);
          } else {
            pref[property] = this.formatPhoneNumber(pref[property]);
          }
        }
        return pref;
      });
    }

    static formatPhoneNumber(phone) {
      if (phone.charAt(0) === '+') {
        return phone.charAt(1) + phone.substring(phone.indexOf('(') + 1, phone.indexOf(')'))
        + phone.substring(phone.indexOf(')') + 2, phone.indexOf('-')) + phone.substring(phone.indexOf('-') + 1);
      }
      return phone;
    }
}

export default FormatHelper;